import React from 'react';
import { connect } from 'react-redux';
import ConstructorLandings from './ConstructorLandings'

const ConstructorLandingsComponent = connect(
    function mapStateToProps(state, {visible, landing, links, onClose, onSave}) {
        return {
            goalEntries: state.goalEntries.list,
            publisherId: state.user.publisher.id,
            publisherIsReferral: state.user.publisher.referral_publisher,
            offer: state.offers.list[0],
            links: links,
            landing: landing,
            visible: visible,
            onClose: onClose,
            onSave: onSave
        };
    },
    function mapDispatchToProps(dispatch) {
        return {};
    }
)(ConstructorLandings);

export default ConstructorLandingsComponent;
